/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "SendTeamMemberInvitationRequest": {
            "fields": {
              "idempotencyKey": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "teamMemberId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "suppressDuplicateInvitations": {
                "type": "bool",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "SendTeamMemberInvitationResponse": {
            "fields": {
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 1,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.SendTeamMemberInvitationRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.SendTeamMemberInvitationResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a send request for a `TeamMemberInvitation` object.
 * --
 *
 * SOURCE SendTeamMemberInvitationRequest @ squareup/team_api/endpoints/send-team-member-invitation.proto at 20:1
 */
export const SendTeamMemberInvitationRequest = $root.lookupType('squareup.team_api.SendTeamMemberInvitationRequest');
fixType(SendTeamMemberInvitationRequest, {
  teamMemberId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SendTeamMemberInvitationRequest);
/**
 * --
 * @desc Represents a response from the send request containing the created `TeamMemberInvitation`
 * object or error messages.
 * --
 *
 * SOURCE SendTeamMemberInvitationResponse @ squareup/team_api/endpoints/send-team-member-invitation.proto at 53:1
 */
export const SendTeamMemberInvitationResponse = $root.lookupType('squareup.team_api.SendTeamMemberInvitationResponse');
fixType(SendTeamMemberInvitationResponse);
Builder.createAndAttachToType(SendTeamMemberInvitationResponse);